import {
  faFacebookSquare,
  faInstagram,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faExternalLinkSquareAlt,
  faUserClock,
} from '@fortawesome/pro-solid-svg-icons';
// @fortawesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import RoomIcon from '@material-ui/icons/Room';
// page styles
import headlinerStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/headlinerStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
// core components
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
// gatsby libraries
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

const useStyles = makeStyles(headlinerStyle);

export default function SectionHeadliner() {
  const {
    chilimaniaLogo,
    chilimaniaHeadlinerImage,
    countryEdgeLogo,
    countryEdgeHeadlinerImage,
    headlinerBackground,
    placeholderImage,
  } = useStaticQuery(graphql`
    query getHeadlinerImages {
      chilimaniaLogo: file(
        relativePath: { eq: "logos/chilimania-logo-transparent-white.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      chilimaniaHeadlinerImage: file(
        relativePath: { eq: "headliners/2025/son-of-a-gun.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      countryEdgeLogo: file(
        relativePath: { eq: "logos/country-edge-logo.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      countryEdgeHeadlinerImage: file(
        relativePath: { eq: "headliners/2025/lauren-alaina.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      headlinerBackground: file(
        relativePath: { eq: "backgrounds/stage-headliner.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      placeholderImage: file(
        relativePath: { eq: "headliners/headliner-placeholder-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GatsbyImage
        className={classes.backgroundImage}
        image={headlinerBackground.childImageSharp.gatsbyImageData}
        alt="Event Photo"
      />
      <div className={classes.backgroundImageText}>
        <div className={classes.container}>
          <h2 className={classes.headlinerTitle}>Headliners</h2>
          <GridContainer
            className={classes.headlinerContainer}
            alignItems="flex-start"
          >
            <GridItem xs={12} sm={8} md={6} className={classes.headlinerItem}>
              <div className={classes.logoContainer}>
                <GatsbyImage
                  image={countryEdgeLogo.childImageSharp.gatsbyImageData}
                  alt="Country Edge Logo"
                  className={classes.eventLogo}
                  objectFit={'contain'}
                />
              </div>
              <Card profile>
                <CardHeader image>
                  <GatsbyImage
                    image={
                      countryEdgeHeadlinerImage.childImageSharp.gatsbyImageData
                    }
                    className={classes.cardBackgroundImage}
                    alt="Country Edge Headliner"
                  />
                </CardHeader>
                <CardBody>
                  <h3 className={classes.cardTitle}>Lauren Alaina</h3>
                  {/* <p className={classes.cardDescription}>
                    Country Edge Headliner Coming Soon!
                  </p> */}
                  <p className={classes.cardDescription}>
                    Lauren Alaina has earned three chart-topping hits: RIAA
                    Platinum-certified “Road Less Traveled,” Diamond “What Ifs”
                    with her childhood friend Kane Brown, and 3X Platinum “ONE
                    BEER” with labelmate HARDY + Devin Dawson. With the Brown
                    duet, Alaina became the only solo country female artist in
                    history to receive the RIAA's Diamond certification on a
                    single.
                    <br />
                    <br />
                    The Georgia-born force, whom American Songwriter notes is
                    “on a seemingly limitless upward trajectory,” has also
                    shared the stage with Alan Jackson, Blake Shelton, Carrie
                    Underwood, Luke Bryan, Martina McBride, and more. This year,
                    she joins the much-anticipated Rascal Flatts Life Is A
                    Highway Tour.
                    <br />
                    <br />
                    The vocalist has performed on some of the highest-profile
                    stages in the world including PBS' A Capitol Fourth, Dancing
                    with the Stars, American Idol, CBS' Beyond The Edge, ABC's
                    The Bachelorette, TODAY, Good Morning America, The Ellen
                    DeGeneres Show, The Kelly Clarkson Show, The Tonight Show,
                    Jimmy Kimmel Live!, Macy's Thanksgiving Day Parade, ABC's
                    CMA Fest specials, CMA and ACM Awards, Nickelodeon's All
                    That, Dallas Cowboys Thanksgiving Day halftime performance,
                    MLB's World Series national anthem performance, a
                    performance at the White House for President Obama, and
                    more.
                  </p>
                  <h5 className={classes.headerIconWrapper}>
                    <RoomIcon className={classes.icons} viewBox="0 0 13 25" />
                    Country Edge Main Stage
                  </h5>
                  <h5 className={classes.headerIconWrapper}>
                    <FontAwesomeIcon
                      icon={faUserClock}
                      className={classes.icons}
                    />
                    10:15 PM
                  </h5>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button
                    href="https://x.com/Lauren_Alaina"
                    justIcon
                    round
                    color="twitter"
                  >
                    <FontAwesomeIcon icon={faTwitter} />
                  </Button>
                  <Button
                    href="https://www.instagram.com/laurenalaina"
                    justIcon
                    round
                    color="instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </Button>
                  <Button
                    href="https://www.facebook.com/LaurenAlaina"
                    justIcon
                    round
                    color="facebook"
                  >
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </Button>
                  <Button
                    href="https://www.youtube.com/c/laurenalaina"
                    justIcon
                    round
                    color="youtube"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </Button>
                  <Button
                    href="https://laurenalaina.com/"
                    justIcon
                    round
                    color="google"
                  >
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={8} md={6} className={classes.headlinerItem}>
              <div className={classes.logoContainer}>
                <GatsbyImage
                  image={chilimaniaLogo.childImageSharp.gatsbyImageData}
                  alt="Chilimania Logo"
                  className={classes.eventLogo}
                  objectFit={'contain'}
                />
              </div>
              <Card profile>
                <CardHeader className={classes.cardHeaderImage} image>
                  <GatsbyImage
                    image={
                      chilimaniaHeadlinerImage.childImageSharp.gatsbyImageData
                    }
                    className={classes.cardBackgroundImage}
                    alt="Chilimania Headliner"
                    // imgStyle={{ objectFit: "contain" }} Just for 2024
                  />
                </CardHeader>
                <CardBody>
                  <h3 className={classes.cardTitle}>Son Of A Gun</h3>
                  <p className={classes.cardDescription}>
                    Son Of A Gun is the best Guns N’ Roses tribute band on
                    planet earth. Fronted by Ari Kamin, lead singer of Steven
                    Adler of Guns N’ Roses, this five piece Rock N’ Roll band
                    based in Los Angeles is able to bring a stadium show to any
                    kind of venue. Formed in 2012 in Argentina, they took
                    advantage of the experience gained in years of touring the
                    United States and quickly became the hottest band in L.A.
                    <br />
                    <br />
                    “Nobody can do Axl except for Axl and the guy that Steven
                    Adler is playing with, Ari, he is amazing as well” — Justin
                    Hawkins (The Darkness)
                    <br />
                    “An Argentinian guy that is just phenomenal. I mean the guy
                    is mean. You got to go on YouTube and see some videos of the
                    guy. He’s amazing” — Jeff Pilson (Foreigner)
                    <br />
                    <br />
                    They have toured the United States extensively, playing at
                    venues such as The Whisky A Go Go, The Viper Room, The House
                    of Blues, and The Roxy Theatre. They have also played at
                    festivals such as the Sunset Strip Music Festival, the NAMM
                    Show, and the Rocklahoma Festival.
                    <br />
                    <br />
                    The group consists of Ari Kamin (vocals), Johnny Mayo
                    (guitar), German Cardelle (guitar), Tinu Cer (bass) and
                    Gustavo (drums).
                  </p>
                  {/* <p className={classes.cardDescription}>
                      Chilimania Headliner Coming Soon!
                    </p> */}
                  <h5 className={classes.headerIconWrapper}>
                    <RoomIcon className={classes.icons} viewBox="0 0 13 25" />
                    105.9 THE HOG Main Stage
                  </h5>
                  <h5 className={classes.headerIconWrapper}>
                    <FontAwesomeIcon
                      icon={faUserClock}
                      className={classes.icons}
                    />
                    10:15 PM
                  </h5>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {/* <Button
                      href="https://twitter.com/RealBackInBlack"
                      justIcon
                      round
                      color="twitter"
                    >
                      <FontAwesomeIcon icon={faTwitter} />
                    </Button> */}
                  <Button
                    href="https://www.instagram.com/thebestgnrtribute/"
                    justIcon
                    round
                    color="instagram"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </Button>
                  <Button
                    href="https://www.facebook.com/SonOfAGunMusic"
                    justIcon
                    round
                    color="facebook"
                  >
                    <FontAwesomeIcon icon={faFacebookSquare} />
                  </Button>
                  <Button
                    href="https://www.youtube.com/@sonofagunofficial"
                    justIcon
                    round
                    color="youtube"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </Button>
                  <Button
                    href="https://sonofaguntribute.com/"
                    justIcon
                    round
                    color="google"
                  >
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} />
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}
